import mask from "@/store/tutorial/mask.store";
import steps from "@/store/tutorial/steps/list.store";
import { LOCAL } from "@/store/mutations";

const { ACTIVATE_TUTORIAL, DEACTIVATE_TUTORIAL } = LOCAL;

export default {
	namespaced: true,
	modules: {
		mask,
		steps,
	},
	state: {
		active: false,
	},
	actions: {
		start({ commit }) {
			commit(ACTIVATE_TUTORIAL);
		},
		complete({ commit, dispatch }) {
			commit(DEACTIVATE_TUTORIAL);
			dispatch("mask/deactivate");
		},
	},
	mutations: {
		[ACTIVATE_TUTORIAL](state) {
			state.active = true;
		},
		[DEACTIVATE_TUTORIAL](state) {
			state.active = false;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/tutorial/index.js